<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Complete Your Profile</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<div class="modal-body">
  <div class="text-center mb-4">
    <h5>Are your details up to date?</h5>
    <p class="text-muted">
      Review and update your profile information below to help us provide a better experience tailored to your interests
      and role.
    </p>
  </div>

  <eng-profile-form #profileForm (success)="onSuccess()" (submit)="onSubmit()"></eng-profile-form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="remindLater()">Remind Me Later</button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="profileForm.onSubmit()"
    [disabled]="!profileForm.formValid || profileForm.submitting">
    @if (profileForm.submitting) {
      <span class="spinner-border spinner-border-sm me-2" role="status">
        <span class="visually-hidden">Saving...</span>
      </span>
    }
    Update Profile
  </button>
</div>
